import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ButtonStatusVariant } from '../../../components/ButtonWithFeddback';
import { LoginFormValues } from '../../../components/LoginForm/useLoginForm';
import useHandleAppException, { AppExceptionResponse } from '../../../hooks/useHandleAppException';
import PATHS from '../../../routes/routes.const';
import api from '../../../services/api';
import snackbarStore from '../../../stores/Snackbar.store';
import { sleep } from '../../../utils/generics';
import { OAuthConsentLocationState } from '../pages/OAuthConsentPage';

interface UseOAuthLoginReturn {
  handleLogin: (values: LoginFormValues) => Promise<void>;
  loginStatus: ButtonStatusVariant;
}

const useOAuthLogin = (oauthRequestId: string): UseOAuthLoginReturn => {
  const [loginStatus, setLoginStatus] = useState<ButtonStatusVariant>('normal');
  const { handleErrorResponse } = useHandleAppException();
  const history = useHistory();

  const handleLogin = async (values: LoginFormValues) => {
    setLoginStatus('loading');

    const response = await api.oauthLogin({
      email: values.email,
      password: values.password,
      oauth_request_id: oauthRequestId,
    });

    if (response.ok && response.data?.redirect_to) {
      window.location.href = response.data.redirect_to;
      return;
    }

    if (response.ok && response.data?.requires_consent) {
      const state: OAuthConsentLocationState = {
        oauthRequestId: response.data.oauth_request_id || '',
        clientName: response.data.client_name || '',
        scopes: response.data.scopes || [],
      };
      history.push(PATHS.public.oauthConsent.path, state);
      return;
    }

    setLoginStatus('error');
    const message = handleErrorResponse(response as unknown as AppExceptionResponse);
    snackbarStore.handleMessage({ type: 'error', message });

    await sleep(1500);
    setLoginStatus('normal');
  };

  return { handleLogin, loginStatus };
};

export default useOAuthLogin;
